import React, { useState } from 'react';
import { TableDisplay } from "./Common";
import { PowerEntry } from "./PowerEntry";
import { ProcEntry } from "./ProcEntry";
import { ProcChanceChart, ProcDamageChart } from "./PDChart";


function ProcDisplay({ procs, onAdd, onRemove }) {
    return (<TableDisplay
        headings={['Proc name', 'PPM', 'Damage']}
        values={procs}
        keys={['name', 'ppm', 'damage']}
        name={'Proc'}
        onAdd={onAdd}
        onRemove={onRemove} />);
}

function PowerDisplay({ powers, onAdd, onRemove }) {
    return (<TableDisplay
        headings={['Power name', 'Cast Time', 'Arcanatime', 'Damage', 'Recharge', 'Radius', 'Arc']}
        values={powers}
        keys={['name', 'cast_time', 'arcanatime', 'damage', 'recharge', 'radius', 'arc']}
        name={'Power'}
        onAdd={onAdd}
        onRemove={onRemove} />);
}

function valid_data(powers, procs) {
    if(powers.length == 0 || procs.length == 0)
        return false;

    return true;
}

export const ProcChartEntry = () => {
    const default_state = {powers: [], procs: [], state: '', valid: false};
    const [data, setData] = useState(default_state);

    const cancel = (e) => {
        setData({...data, state: ''});
    }

    if(data.state == 'power') {
        const power_add = (power) => {
            let new_powers = [...data.powers, power];
            setData({...data, 
                powers: new_powers,
                state: '', 
                valid: valid_data(new_powers, data.procs)
            });
        }
    
        return (
            <div>
                <PowerEntry onAdd={power_add} onCancel={cancel}/>
            </div>
        );
    }

    if(data.state == 'proc') {
        const proc_add = (proc) => {
            let new_procs = [...data.procs, proc];
            setData({...data, 
                procs: new_procs,
                state: '',
                valid: valid_data(data.powers, new_procs)
            });
        }

        return (
            <div>
                <ProcEntry onAdd={proc_add} onCancel={cancel}/>
            </div>
        );
    }

    if(data.state == 'cchart') {
        return (
            <div>
                <ProcChanceChart powers={data.powers} procs={data.procs}/>
                <button type="button" className="btn btn-primary" onClick={cancel}>Back</button>
            </div>
        );
    }

    if(data.state == 'dchart') {
        return (
            <div>
                <ProcDamageChart powers={data.powers} procs={data.procs}/>
                <button type="button" className="btn btn-primary" onClick={cancel}>Back</button>
            </div>
        );
    }

    const add_power = () => {
        setData({...data, state: 'power'});
    }

    const add_proc = () => {
        setData({...data, state: 'proc'});
    }

    const remove_power = (ndx) => {
        let item = data.powers[ndx];
        const not_item = (thing => thing !== item);
        setData({...data, powers: data.powers.filter(not_item)});
    }

    const remove_proc = (ndx) => {
        let item = data.procs[ndx];
        const not_item = (thing => thing !== item);
        setData({...data, procs: data.procs.filter(not_item)});
    }

    const cchart = () => {
        setData({...data, state: 'cchart'});
    }

    const dchart = () => {
        setData({...data, state: 'dchart'});
    }

    const reset = () => {
        setData(default_state);
    }

    return (
        <div>
            <PowerDisplay powers={data.powers} onAdd={add_power} onRemove={remove_power} />
            <ProcDisplay procs={data.procs} onAdd={add_proc} onRemove={remove_proc} />
            <button type="button" className="btn btn-primary" disabled={!data.valid} onClick={cchart}>Generate Chance Chart</button>
            <button type="button" className="btn btn-primary" disabled={!data.valid} onClick={dchart}>Generate Damage Chart</button>
            <button type="button" className="btn btn-secondary" onClick={reset}>Reset</button>
        </div>
    );
}